import dayjs from "dayjs";
import RecordsLineUser from "./records-line-user";

/** Строка в таблице предварительной записи */
const RecordsLine = ({hour, users, height, timeWidth, userWidth, isToday, grafs, onSelectTime, vid, onResizeHeight}) => {

  const position = (isToday && dayjs().hour() === hour) ? (height * dayjs().minute() / 60) : null;

  // Отображаемое время в минутах с начала дня
  const hStart = hour * 60;
  const hFinish = hStart + 60;
  const hGrafs = grafs.filter(i => i.startMin < hFinish && i.finishMin> hStart);

  const divTime = <div style={{width: timeWidth, height: height, position: 'relative' }} key={0}>
    <div>{hour}:00</div>
    {position !== null && <div className="records-line-time-today" style={{top: position - 3 }} />}
    {/* Риски времени 1/4, 1/2, 3/4 */}
    <div className="records-line-time-marks">
      <div className="records-line-time-mark" style={{top: '25%'}} />
      <div className="records-line-time-mark" style={{top: '50%'}} />
      <div className="records-line-time-mark" style={{top: '75%'}} />
    </div>
    <div 
      className="resize-handle-height"
      style={{
        position: 'absolute',
        left: 0,
        right: 0,
        bottom: -2,
        height: 4,
        cursor: 'row-resize',
        background: 'transparent',
        zIndex: 100
      }}
      onMouseDown={onResizeHeight}
    />
  </div>

  const divCols = [divTime, ...users.map(item => <RecordsLineUser 
    user={item}
    height={height}
    width={userWidth}
    key={item.id}
    position={position}
    grafs={hGrafs}
    start={hStart}
    finish={hFinish}
    onSelect={onSelectTime}
    vid={vid}
  />)]

  return<div className="records-line">
    {divCols}
  </div>

}

export default RecordsLine;